// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___vm7vK","root__group":"style-module__root__group___A8n3A","root__group_text":"style-module__root__group_text___kLuAi","root__group_btn":"style-module__root__group_btn___FzCeh"};
    if(module.hot) {
      // 1697460456625
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  